import { render, staticRenderFns } from "./VaColorInput.vue?vue&type=template&id=41531b31&scoped=true&"
import script from "./VaColorInput.vue?vue&type=script&lang=js&"
export * from "./VaColorInput.vue?vue&type=script&lang=js&"
import style0 from "./VaColorInput.vue?vue&type=style&index=0&id=41531b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41531b31",
  null
  
)

export default component.exports